// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__2k-WE","body":"Page_body__2L9WB","content":"Page_content__AAcW6","padding":"Page_padding__jmKtM"};